export default "__VITE_ASSET__Dl3loWLM__"